
import Vue from 'vue'
import i18n from '@/locales/_i18n';

const getDefaultState = () => {
    return {
        distribuidorConfig: {
            id: 0,
            idDistribuidor: "",
            valorCredito: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("distribuidor/config/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listDistribuidorConfig = result.data.result;

                return listDistribuidorConfig;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar as configurações dos distribuidores: [${ex}]`
            };
        }
    },

    async ListByDistribuidor(_, idDistribuidor) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`distribuidor/config/list-by-distribuidor/${idDistribuidor}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listDistribuidorConfig = result.data.result;

                return listDistribuidorConfig;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar as configurações do distribuidor: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`distribuidor/config/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter configuração do distribuidor`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter configuração do distribuidor: [${ex}]`
            };
        }
    },

    async GetByDistribuidor(_, idDistribuidor) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`distribuidor/config/get-by-distribuidor/${idDistribuidor}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter configuração do distribuidor`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter configuração do distribuidor: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, distribuidorConfigRequest) {

        try {

            const result = await Vue.prototype.$spTechApi.post(`distribuidor/config/create-update`, distribuidorConfigRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Registro atualizado com sucesso!";

                if (distribuidorConfigRequest.id === 0) {
                    msg = "Registro criado com sucesso!";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error}]`
                };
            }
        }
    },

    async AlterarStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$spTechApi.put(`distribuidor/config/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Configuração do distribuidor atualizado com sucesso!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Erro ao atualizar o status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao atualizar o status: [${ex}]`
            };
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.delete(`distribuidor/config/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Registro excluído com sucesso!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Erro ao excluir registro: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Erro ao excluir registro: [${error}]`
                };
            }
        }
    },

    async ListHistorico(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`distribuidor/config/list-historico/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listHistorico = result.data.result;

                return listHistorico;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar o histórico: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.distribuidorConfig, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.distribuidorConfig;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
